import React from "react";
import { Grid } from "@mui/material";
import FormDatePicker from "app/components/form-components/FormDatePicker";
import dayjs from "dayjs";
function StartEndDate({
  control,
  isEditPath,
  preloadedData,
  dateToday,
  startDate,
  endDate,
  errors,
  clearErrors
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FormDatePicker
          control={control}
          name={"jp_start_date"}
          minDate={isEditPath ? dayjs(preloadedData.jp_start_date) : dateToday}
          format={"DD/MM/YYYY"}
          rules={{
            validate: (fieldValue) => {
              const date = dayjs(fieldValue);
              if (!date.isValid()) {
                return "Invalid date";
              }
              if (date.isAfter(dayjs(endDate))) {
                return "Start date cannot be after end date";
              }
            }
          }}
          label={"Start Date"}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePicker
          control={control}
          name={"jp_end_date"}
          format={"DD/MM/YYYY"}
          rules={{
            validate: (fieldValue) => {
              const endDate = dayjs(fieldValue);
              if (!endDate.isValid()) {
                return "Invalid date";
              }
              // Check start date is not undefined if undefined isBefore will return true every time
              const isEndDateBeforeStartDate = startDate
                ? endDate.isBefore(dayjs(startDate))
                : endDate.isBefore(dayjs(preloadedData.jp_start_date));
              if (isEndDateBeforeStartDate) {
                return "End date cannot be before start date";
              } else {
                if (errors.jp_start_date) {
                  clearErrors("jp_start_date");
                }
              }
            }
          }}
          minDate={
            isEditPath
              ? dayjs(preloadedData.jp_start_date)
              : startDate
                ? dayjs(startDate)
                : undefined
          }
          label={"End Date"}
        />
      </Grid>
    </Grid>
  );
}

export default StartEndDate;
